<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'GoogleMapMarker',
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marcador: {
      type: Object,
      required: true,
    },
  },
  methods: {
    setMarker() {
      const marker = new this.google.maps.Marker({
        position: this.marcador.posicion,
        map: this.map,
        title: this.marcador.titulo,
      });

      marker.addListener('click', () => {
        eventBus.$emit('details', this.marcador.idReference);
      });
    },
  },

  mounted() {
    this.setMarker();
  },
  render() {
    return {};
  },
};
</script>
